
import { Card, Form, Row, Col, Button} from 'react-bootstrap';
import Block from '../Block/Block';
import { useState } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';

const FileUpload = ({handleUpload,handlechange,isFilePicked,msg}) => {


const[isProcessing, setisProcessing] = useState(false);

//   const[selectedFile, setSelectedFile] = useState(null);
//   const [isFilePicked, setIsFilePicked] = useState(false);
//   const [error, setError] = useState(null);
//   const [msg, setMsg] = useState(null);

//   const handlechange = (e)=>{

//     setSelectedFile(e.target.files[0]);
//     setIsFilePicked(true);


//     //alert(selectedFile.name);
//     //console.log(selectedFile);
//     //return null
//   }  


 const handleUploadLocal = () => {
    setisProcessing(true);
    handleUpload();
 }
//     const frmFormData = new FormData();
// 	  frmFormData.append('File', selectedFile);

//     const sURL = SiteConfig.API_BASE_URL + "Storage/Upload/";
       
//       const headers = {
//           'Content-Type': selectedFile.type,
//           'Authorization': 'Bearer '+ localStorage.getItem(SiteConfig.API_AUTH_TOKEN)      
//         };

//       axios.post(sURL,frmFormData,{headers})
//       .then((Response)=>{
//           //setClients(Response.data);
//           console.log(Response.data)
//          let res = Response.data
//          setMsg(res.status);
//          setSelectedFile(null);
//          stateChanger(true);
//       }).catch(error => {
//           setError(error);     
//           //console.log({error})
//       });

//   alert('sss');

// }


  return (
    <>
    <Block>        
        <Card>
          <Card.Body>
            <Row className="gx-gs gy-3">
                <Col sm="6">
                    <div className="form-group">
                        <Form.Label>Upload a Document</Form.Label>
                        <div className="form-control-wrap">
                            <Form.Control type="file" onChange={handlechange}/>
                        </div>                        
                    </div>                    
                </Col>      
                {/* {msg != null ?? <alert>{msg}</alert>}                        */}
                {isFilePicked && !isProcessing && <Button onClick={handleUploadLocal} > Upload </Button> }
                {isProcessing && <ProgressBar animated variant="success" now={50}/>}
                {msg}              
            </Row>           
           </Card.Body>          
        </Card>
      </Block>    
    </>
    
  )
}

export default FileUpload